import React, { useState } from "react";
import Button from "./Button";

type Props = {
  clientId: string;
  onAuthed?: () => void;
};

export default function GoogleCalendarAuth({ clientId }: Props) {
  const [error, setError] = useState<string | null>(null);
  const [debug, setDebug] = useState<string | null>(null);

  const connect = () => {
    setError(null);
    setDebug(null);

    try {
      if (!clientId || clientId.trim() === "") {
        setError("Client ID is not configured. Check REACT_APP_GOOGLE_CAL_CLIENT_ID in .env");
        return;
      }

      const redirectUri = `${window.location.origin}/oauth/callback`;
      const scope = "https://www.googleapis.com/auth/calendar.readonly";

      // Build OAuth URL with proper parameters
      const authUrl = new URL("https://accounts.google.com/o/oauth2/v2/auth");
      authUrl.searchParams.set("client_id", clientId);
      authUrl.searchParams.set("redirect_uri", redirectUri);
      authUrl.searchParams.set("response_type", "code");
      authUrl.searchParams.set("scope", scope);
      authUrl.searchParams.set("access_type", "offline");
      authUrl.searchParams.set("prompt", "consent");

      // Debug: Log the details
      console.log("=== OAuth Debug Info ===");
      console.log("Redirect URI:", redirectUri);
      console.log("Client ID:", clientId);
      console.log("Full OAuth URL:", authUrl.toString());
      console.log("========================");

      setDebug(`Redirecting to Google... Check console for details`);

      // Redirect to Google OAuth consent screen
      setTimeout(() => {
        window.location.href = authUrl.toString();
      }, 500);
    } catch (e: any) {
      setError(e?.message ?? "Failed to initiate OAuth flow");
      console.error("OAuth error:", e);
    }
  };

  return (
    <div>
      <Button onClick={connect} className="primary-btn p-3">
        Connect Google Calendar
      </Button>

      {debug && <div style={{ marginTop: 8, color: "blue" }}>{debug}</div>}
      {error && <div style={{ marginTop: 8, color: "crimson" }}>{error}</div>}
    </div>
  );
}
